/* THE BLUEPRINT — blueprint.js */
document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', function() {
  initScrollReveals();
  initMobileNav();
  initCartForms();
  updateCartCount();
});

function initScrollReveals() {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.reveal').forEach(function(el) { el.classList.add('in-view'); });
    return;
  }
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -50px 0px' });
  document.querySelectorAll('.reveal').forEach(function(el) { observer.observe(el); });
}

function initMobileNav() {
  var openBtn = document.getElementById('mobileMenuBtn');
  var closeBtn = document.getElementById('mobileCloseBtn');
  var nav = document.getElementById('mobileNav');
  var overlay = document.getElementById('mobileNavOverlay');
  if (!openBtn || !nav || !overlay) return;

  function openNav() {
    nav.classList.add('is-open');
    nav.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-visible');
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    openBtn.classList.add('is-active');
  }
  function closeNav() {
    nav.classList.remove('is-open');
    nav.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-visible');
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    openBtn.classList.remove('is-active');
  }

  openBtn.addEventListener('click', openNav);
  if (closeBtn) closeBtn.addEventListener('click', closeNav);
  overlay.addEventListener('click', closeNav);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && nav.classList.contains('is-open')) closeNav();
  });
}

function initCartForms() {
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form.classList.contains('product-atc-form') && !form.classList.contains('book-atc-form')) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (!btn) return;
    var orig = btn.innerHTML;
    btn.innerHTML = 'Adding...';
    btn.disabled = true;
    var id = form.querySelector('[name="id"]');
    if (!id) { btn.innerHTML = orig; btn.disabled = false; return; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id.value, quantity: 1 })
    })
    .then(function(r) { if (!r.ok) throw new Error(); return r.json(); })
    .then(function() {
      btn.innerHTML = '&#10003; Added to Cart';
      updateCartCount();
      setTimeout(function() { btn.innerHTML = orig; btn.disabled = false; }, 2200);
    })
    .catch(function() { btn.innerHTML = orig; btn.disabled = false; });
  });
}

function updateCartCount() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      document.querySelectorAll('.cart-badge').forEach(function(badge) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    })
    .catch(function() {});
}

// Hero watermark parallax
window.addEventListener('scroll', function() {
  var wm = document.querySelector('.hero-watermark');
  if (wm) wm.style.transform = 'translateY(' + (window.scrollY * 0.25) + 'px)';
}, { passive: true });